import { t, Trans } from "@lingui/macro";

import { FaqItem } from "./FaqItem";

export function FaqSection() {
  return (
    <section className="flex w-full bg-slate-800 px-16 py-[120px] text-white sm:px-40">
      <div className="mx-auto flex w-[1200px] flex-col justify-between gap-36 overflow-hidden sm:flex-row sm:gap-[120px]">
        <h2 className="text-heading-2">
          <Trans>FAQ</Trans>
        </h2>
        <div className="flex w-full flex-col gap-12 sm:w-[800px]">
          <FaqItem title="Why is TMX one of the top places to farm real yield in DeFi?">
            <Trans>
              <p>
                Liquidity providers on TMX earn 58% of all trading and liquidation fees. By depositing WBTC, ETH, USDC,
                and other supported assets, you can tap into up to ~40% APY on the deepest pools in DeFi.
              </p>
              <ul className="list-disc pl-14">
                <li> TM Pools — Get single-asset exposure for focused, high-conviction yield.</li>
                <li> TLV Vaults — Diversify across markets automatically for a passive, optimized strategy.</li>
              </ul>
              <p>
                Both have historically outperformed traditional LP benchmarks. Check live performance on the Pools
                dashboard.
              </p>
            </Trans>
          </FaqItem>
          <FaqItem title={t`How do I start using TMX?`}>
            <Trans>
              <p>No KYC. No waiting list. No centralized custody. Just connect your wallet and trade.</p>
              <ul className="list-decimal pl-20">
                <li>
                  Connect any EVM-compatible wallet (MetaMask, Rabby, Coinbase Wallet, Trust Wallet, OKX Wallet, Ledger,
                  etc.)
                </li>
                <li>Select a supported chain where you hold funds</li>
                <li>Start trading immediately</li>
              </ul>
              <p>
                Trade directly on Arbitrum or deposit to your TMX Account to access liquidity from any supported
                multichain network.
              </p>
            </Trans>
          </FaqItem>
          <FaqItem title={t`What makes TMX more capital-efficient than other perp DEXs?`}>
            <Trans>
              <p>
                TMX uses a multi-asset liquidity pool model instead of an order book. This allows for deep, low-slippage
                liquidity — traders can open positions worth $50M+ with minimal price impact. Sometimes, you even earn
                from positive price impact during execution.
              </p>

              <p>
                Liquidations are handled via Chainlink and Chaos Labs decentralized oracles, aggregating multiple price
                feeds to eliminate manipulation and ensure fair execution.
              </p>
            </Trans>
          </FaqItem>
          <FaqItem title={t`Can developers build on TMX or integrate it into other DeFi protocols?`}>
            <Trans>
              <p>
                Absolutely. TMX is fully composable and already plugged into hundreds of DeFi platforms — including
                Pendle, Dolomite, Radiant, Silo Finance, Venus Protocol, Abracadabra, Compound, and Beefy. You can build
                directly on top of TMX smart contracts or use its APIs and SDKs to integrate trading, liquidity, or
                analytics features into your own app. Explore the TMX Developer Docs to get started.
              </p>
            </Trans>
          </FaqItem>
        </div>
      </div>
    </section>
  );
}
